import { Film, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { GenerateFullVideoButton } from '@/components/video';
import { LayoutToggle } from './PropertySceneEditorSettings';
import type { IPropertySceneEditorHeaderProps } from '@/@types/propertySceneEditor';

export function PropertySceneEditorHeader({
  layout,
  onLayoutChange,
  hasExistingVideo,
  onViewExistingVideo,
  onGenerateFullVideo,
  isGenerating,
  isFullVideoReady,
  fullVideoReadyMessage,
  finalVideoUrl,
  propertyVideoAdapter,
}: IPropertySceneEditorHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-lg font-medium">Video Scenes</h3>
      <div className="flex items-center gap-3">
        {hasExistingVideo && onViewExistingVideo && (
          <Button onClick={onViewExistingVideo} variant="outline" className="min-w-40">
            <Film className="mr-2 h-4 w-4" />
            View Video
          </Button>
        )}
        {onGenerateFullVideo ? (
          <Button
            onClick={onGenerateFullVideo}
            disabled={!isFullVideoReady || isGenerating}
            className="min-w-50"
          >
            {isGenerating ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Generating...
              </>
            ) : (
              <>
                <Film className="mr-2 h-4 w-4" />
                {hasExistingVideo ? 'Regenerate Video' : 'Generate Full Video'}
              </>
            )}
          </Button>
        ) : propertyVideoAdapter ? (
          <GenerateFullVideoButton
            adapter={propertyVideoAdapter}
            isReady={isFullVideoReady}
            readyMessage={fullVideoReadyMessage}
            existingVideoUrl={finalVideoUrl}
            buttonLabel="Generate Full Video"
          />
        ) : null}
        <LayoutToggle layout={layout} onLayoutChange={onLayoutChange} />
      </div>
    </div>
  );
}
